import { useMemo } from 'react';

import {
	buildUserDetailsCFValidators,
	type BuildUserDetailsCFValidatorsOptions,
} from '@/utils/convertFlowFieldValidators/convertFlowFieldValidators';

import { useConvertFlowValidation } from '../useConvertFlowValidation/useConvertFlowValidation';

export interface UseConvertFlowUserDetailsValidationOptions extends BuildUserDetailsCFValidatorsOptions {
	/**
	 * When false, no validators are registered. Defaults to true so callers
	 * who do not pass the option get the standard behavior.
	 */
	enabled?: boolean;
}

/**
 * Opinionated wrapper that registers ConvertFlow validators for the
 * standard UserDetails form fields (`name`, `last_name`, `email`, `phone`,
 * `zip_code`) using the shared validation atoms and async services.
 *
 * Intended to be called by `ConvertFlowQuiz` whenever the Contentful entry
 * has `enableUserDetailsValidation` set.
 */
export function useConvertFlowUserDetailsValidation(options: UseConvertFlowUserDetailsValidationOptions = {}): void {
	const { enabled = true, isSpanish = false, validateSubmission } = options;

	const validators = useMemo(
		() => (enabled ? buildUserDetailsCFValidators({ isSpanish, validateSubmission }) : {}),
		[enabled, isSpanish, validateSubmission]
	);

	useConvertFlowValidation(validators);
}
